var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Providers',{attrs:{"assetType":_vm.form.assetType,"errors-post":_vm.errorsPost.providers,"object-id":_vm.objectId,"no-save":_vm.noSave},model:{value:(_vm.form.providers),callback:function ($$v) {_vm.$set(_vm.form, "providers", $$v)},expression:"form.providers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }